import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { withRouter } from "react-router-dom";
import WeatherWebUI from "../../components/Advisor/Weather";

class Weather extends Component {
  onSelectProvider = provider => {
    console.log("Select provider", provider);
    window.open(provider.url, "_blank");
  };

  render() {
    return (
      <WeatherWebUI
        providers={this.props.providers}
        onSelect={this.onSelectProvider}
      />
    );
  }
}

const mapStateToProps = state => ({
  providers: state.weatherProviders.data.filter(provider => provider.active)
});

export default connect(
  mapStateToProps,
  null
)(withNamespaces(["weather", "common"])(withRouter(Weather)));
